/* US PDP stock gate. No cart, inventory, Downpay or wishlist data is changed. */
(() => {
  if (window.bwPurchaseStock) return;
  const selector = '[data-bw-purchase-control], #downpay-buy-button, product-form [name="add"], product-form .shopify-payment-button__button, .custom_prime1_purchase';
  const roots = new WeakSet();
  const locks = new WeakMap();
  function blocked(root) { return root?.getAttribute('data-bw-purchase-blocked') === 'true'; }
  function sync(root) {
    const unavailable = blocked(root);
    root.querySelectorAll('[data-bw-deposit-stock-gate]').forEach(gate => {
      if (gate.hasAttribute('disabled') !== unavailable) gate.toggleAttribute('disabled', unavailable);
    });
    root.querySelectorAll(selector).forEach(control => {
      // A configured external link navigates elsewhere; it never adds US stock.
      if (control.matches('a[data-bw-external-purchase]')) return;
      if (unavailable) {
        if (!locks.has(control)) locks.set(control, {
          disabled: control.hasAttribute('disabled') && !control.hasAttribute('data-bw-stock-disabled'),
          aria: control.hasAttribute('data-bw-stock-disabled') ? null : control.getAttribute('aria-disabled'),
        });
        if (control.localName !== 'a' && !control.hasAttribute('disabled')) control.setAttribute('disabled', '');
        if (control.getAttribute('aria-disabled') !== 'true') control.setAttribute('aria-disabled', 'true');
      } else if (locks.has(control)) {
        const previous = locks.get(control);
        if (!previous.disabled) control.removeAttribute('disabled');
        if (previous.aria === null) control.removeAttribute('aria-disabled');
        else control.setAttribute('aria-disabled', previous.aria);
        locks.delete(control);
      }
    });
  }
  function init() {
    document.querySelectorAll('product-info[data-bw-purchase-blocked]').forEach(root => {
      if (roots.has(root)) return;
      roots.add(root);
      sync(root);
      // App initialization must not re-enable sold-out purchase controls.
      new MutationObserver(() => sync(root)).observe(root, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'data-bw-purchase-blocked'],
      });
    });
  }
  function stopSoldOut(event) {
    const target = event.target;
    const control = event.type === 'submit' ? target : target.closest?.(selector);
    if (event.type === 'click' && control?.matches('a[data-bw-external-purchase]')) return;
    const root = control?.closest('product-info[data-bw-purchase-blocked]');
    if (!blocked(root)) return;
    if (event.type === 'submit' && !control.matches('form[action*="/cart/add"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    sync(root);
  }
  window.bwPurchaseStock = { blocked, sync };
  window.addEventListener('click', stopSoldOut, true);
  window.addEventListener('submit', stopSoldOut, true);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, event => {
      const source = event.data?.html?.querySelector('product-info[data-bw-purchase-blocked]');
      const root = document.getElementById('ProductInfo-' + event.data?.sectionId);
      if (source && root) {
        root.setAttribute('data-bw-purchase-blocked', source.getAttribute('data-bw-purchase-blocked'));
        sync(root);
      }
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
